import { ref } from "vue";
import { getNewUiFromCookie, setNewUiCookie } from "@/lib/cookie";

const LEGACY_FLAGS_KEY = "feature-flags";
const URL_PARAM = "newUi";

const loadLegacyPreference = (): boolean => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(LEGACY_FLAGS_KEY) ?? "{}");

    return (
      typeof parsed === "object" &&
      parsed !== null &&
      (parsed as { newUi?: unknown }).newUi === true
    );
  } catch {
    return false;
  }
};

const loadPreference = (): boolean => {
  const fromCookie = getNewUiFromCookie();

  return fromCookie === null ? loadLegacyPreference() : fromCookie;
};

const preference = ref<boolean>(loadPreference());

export const isNewUiPreferred = (): boolean => preference.value;

export const setNewUiPreferred = (value: boolean): void => {
  preference.value = value;
  setNewUiCookie(value);
};

export const useNewUiPreference = (): typeof preference => preference;

export const applyNewUiFromUrl = (): void => {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(URL_PARAM);

  if (value !== "1" && value !== "0") {
    return;
  }

  setNewUiPreferred(value === "1");
  url.searchParams.delete(URL_PARAM);
  window.history.replaceState(window.history.state, "", url);
};
